export function copyToClipboard(data: string, nodeTarget = document.body) {
	const elem = document.createElement('textarea');
	elem.textContent = data; // Fix for MS Edge
	elem.value = data;

	// MS Edge do not take style in Object
	elem.style.position = 'absolute';
	elem.style.left = '-9999px';
	nodeTarget.appendChild(elem);

	if (/ipad|iphone/i.exec(window.navigator.userAgent)) {
		elem.contentEditable = 'true';
		elem.readOnly = true;

		const range = document.createRange();
		range.selectNodeContents(elem);
		const selection = window.getSelection();
		if (selection) {
			selection.removeAllRanges();
			selection.addRange(range);
		}
		elem.setSelectionRange(0, data.length);
	} else {
		elem.select();
	}

	document.execCommand('copy');

	nodeTarget.removeChild(elem);
}
